





















import { defineComponent } from '@nuxtjs/composition-api';
import { SfButton } from '~/components/StorefrontUi';
import { FormName } from '~/modules/customer/components/LoginModal/forms/types';

export default defineComponent({
  components: {
    SfButton,
  },
  props: {},
  setup(_, { emit }) {
    const changeForm = (formToNavigateTo: FormName) => {
      emit('change-form', formToNavigateTo);
    };

    return { changeForm };
  },
});
